<template>
    <div>
      <h4>{{answer.content.title}}</h4>
      <span>{{answer.content.subtitle}}</span>
      
      <div class="videoCard_video">
          <video v-bind:src="answer.content.media[0].url" type="video/mp4" controls style="width:100%;">
              Your browser does not support the video tag.
          </video>
      </div>
      <div class="textDiv">
          {{answer.content.text}}
      </div>

      <div class="buttonDiv">
          <div v-for="button in answer.content.buttons">
              <div v-if="button.type === 'openUrl'">
                  <a @click="navigateTo(button.value)" class="btn">{{button.title}}</a>
              </div>
          </div>
          <div v-if="answer.showExpanded" class="returnBtnDiv">
            <a @click="returnClicked($event)" class="btn returnBtn">Return</a>
          </div>
      </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";

export default {
  name: "VideoCard",
  props: ["answer"],
  methods: {
   ...mapActions({
      navigateTo: "navigateTo",
      callParent: "callParent"
    }),
    returnClicked(event) {
      this.$emit('returnClickedVideo', event);
    }
  }
};
</script>

<style scoped>
a {
  color: #42b983;
}

.videoCard_video {
  margin-top: 10px;
}

.textDiv {
  margin: 10px 0;
}

.buttonDiv {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  margin-right: -3%;
  margin-left: -3%;
  margin-bottom: -1.5%;
}

.returnBtnDiv {
  margin-left: auto;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.6rem 0.75rem;
  font-size: .8rem;
  line-height: 1.5;
  border-radius: 10px;
  color: #fff;
  background-color:#195a9a;
  text-decoration: none;
  cursor: pointer;
}

.returnBtn {
  background-color: #2e4c30;
}
</style>

